export default __webpack_public_path__ + "static/media/user sign in.7d5dc06b.png";